import { oneOf } from "prop-types";
import cx from "classnames";

const propTypes = {
  theme: oneOf(["orange"]),
};

const ShareIcons = (props) => {
  const { theme } = props;

  const pageTitle = document.querySelector("meta[name='title']");
  const pageDescription = document.querySelector("meta[name='description']");

  // og might be undefined, so only get the content if it is defined
  const getContent = (metaInfo) =>
    metaInfo ? metaInfo.getAttribute("content") : "";

  const title = encodeURIComponent(getContent(pageTitle));
  const pageUrl = encodeURIComponent(window.location.href);

  const nonEncodedText = getContent(pageDescription);
  const encodedText = encodeURIComponent(nonEncodedText);

  const ellipsis = "...";
  const maxTweetLength = 280;
  const maxTextLength = maxTweetLength - pageUrl.length - 1; // -1 because Twitter adds a space between the text and url
  const truncatedText =
    nonEncodedText.length > maxTextLength
      ? nonEncodedText.substring(0, maxTextLength - ellipsis.length) + ellipsis
      : nonEncodedText;

  const tweetTextNoLink = encodeURIComponent(truncatedText);
  // for twitter not currently used
  // const hashTags = ["EGH"];
  // const via = "EGH";

  const twitterIcon = {
    id: "twitter",
    icon: (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g fill="none" fillRule="evenodd">
          <circle fill="currentColor" cx="16" cy="16" r="16" />
          <path
            d="M13.418 23c2.064 0 3.893-.527 5.486-1.582 1.458-.942 2.591-2.21 3.399-3.803.785-1.503 1.178-3.062 1.178-4.678 0-.201-.011-.347-.034-.437a7.768 7.768 0 001.784-1.851 7.59 7.59 0 01-2.02.572c.763-.471 1.28-1.122 1.549-1.952a7.19 7.19 0 01-2.255.842 3.997 3.997 0 00-1.161-.808A3.371 3.371 0 0019.914 9c-.629 0-1.212.157-1.75.471a3.458 3.458 0 00-1.28 1.296 3.504 3.504 0 00-.47 1.767c0 .269.022.538.067.807a9.782 9.782 0 01-4.056-1.077A9.744 9.744 0 019.212 9.64a3.383 3.383 0 00-.505 1.767c0 .617.146 1.184.437 1.7a3.92 3.92 0 001.144 1.279 3.327 3.327 0 01-1.581-.472v.068c0 .83.269 1.57.807 2.22a3.56 3.56 0 002.02 1.246 4.486 4.486 0 01-.943.101c-.202 0-.415-.011-.64-.034a3.514 3.514 0 001.23 1.734c.594.46 1.284.69 2.069.69-1.301 1.01-2.77 1.514-4.409 1.514-.314 0-.594-.011-.841-.034C9.638 22.473 11.444 23 13.418 23z"
            fill="#FFF"
            fillRule="nonzero"
          />
        </g>
      </svg>
    ),
  };

  const linkedInIcon = {
    id: "linkedin",
    icon: (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g fill="none" fillRule="evenodd">
          <circle fill="currentColor" cx="16" cy="16" r="16" />
          <path
            d="M10.688 11.375c.458 0 .854-.167 1.187-.5.333-.333.5-.73.5-1.188 0-.458-.167-.854-.5-1.187-.333-.333-.73-.5-1.188-.5-.458 0-.854.167-1.187.5-.333.333-.5.73-.5 1.188 0 .458.167.854.5 1.187.333.333.73.5 1.188.5zM16.843 22v-4.625c0-.73.104-1.281.312-1.656.271-.5.74-.75 1.407-.75.666 0 1.114.281 1.343.844.125.333.188.874.188 1.624V22H23v-5.125c0-1.438-.208-2.5-.625-3.188-.542-.854-1.49-1.28-2.844-1.28-.666 0-1.25.166-1.75.5-.458.27-.791.614-1 1.03h-.031v-1.28h-2.781V22h2.875zm-4.719 0v-9.344H9.219V22h2.906z"
            fill="#FFF"
            fillRule="nonzero"
          />
        </g>
      </svg>
    ),
  };
  const facebookIcon = {
    id: "facebook",
    icon: (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g fill="none" fillRule="evenodd">
          <circle fill="currentColor" cx="16" cy="16" r="16" />
          <path
            d="M16.594 23.5v-7.156h2.281l.375-2.844h-2.656v-1.969c0-.458.083-.791.25-1 .208-.25.593-.375 1.156-.375h1.5V7.625c-.563-.083-1.292-.125-2.188-.125-1.104 0-1.99.328-2.656.984-.666.657-1 1.578-1 2.766v2.25H11.25v2.844h2.406V23.5h2.938z"
            fill="#FFF"
            fillRule="nonzero"
          />
        </g>
      </svg>
    ),
  };
  const emailIcon = {
    id: "email",
    icon: (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g fill="none" fillRule="evenodd">
          <circle fill="currentColor" cx="16" cy="16" r="16" />
          <path
            d="M22.4 9H9.6c-.88 0-1.592.72-1.592 1.6L8 20.2c0 .88.72 1.6 1.6 1.6h12.8c.88 0 1.6-.72 1.6-1.6v-9.6c0-.88-.72-1.6-1.6-1.6zm0 3.2l-6.4 4-6.4-4v-1.6l6.4 4 6.4-4v1.6z"
            fill="#FFF"
            fillRule="nonzero"
          />
        </g>
      </svg>
    ),
  };
  const shareIcons = [twitterIcon, linkedInIcon, facebookIcon, emailIcon];

  const getShareUrl = (id) => {
    // we want the parameters in the url

    switch (id) {
      case "twitter":
        // https://dev.twitter.com/web/tweet-button
        //commenting out via and hashtags until we find out if they are needed
        //twitter.com/intent/tweet?text=${text}&hashtags=${hashTags.join(",",)}&via=${via}&url=${pageUrl}
        return `https://twitter.com/intent/tweet?text=${tweetTextNoLink}&url=${pageUrl}`;
      case "linkedin":
        //https://www.linkedin.com/shareArticle?mini=true&url=${pageUrl}&title=${title}&summary=${truncatedText}
        return `https://www.linkedin.com/shareArticle?mini=true&url=${pageUrl}`;
      case "facebook":
        // https://developers.facebook.com/tools/debug/sharing/
        return `https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`;
      case "email":
        // mailto opens default email client
        return `mailto:?to=placeholder@example.com&subject=${title}&body=${encodedText} - ${pageUrl}`;
    }
  };

  const handleIconClick = (id) => {
    window.open(getShareUrl(id), "_blank");
  };

  return (
    <div
      className={cx("share-icons", {
        "share-icons--orange": theme === "orange",
      })}
    >
      {shareIcons.map((share) => (
        <div className="share-icons__icon-container" key={share.id}>
          <button type="button" onClick={() => handleIconClick(share.id)}>
            {share.icon}
          </button>
        </div>
      ))}
    </div>
  );
};

ShareIcons.propTypes = propTypes;
export default ShareIcons;
